export default (user: { location: string; locations?: string[] }) =>
  Array.from(new Set([user.location, ...(user.locations || [])]));
